'use strict';

module.exports = {
    INCLUDE: 'include',
    EXCLUDE: 'exclude',
};
